import { FC } from 'react'
import { Callout, CalloutText } from 'design-system'

import { TreeNodesProps } from './types'
import { TreeItem } from './tree-item'
import { hasChildren, hasChildrenInFiltered, getChildren } from './helpers'

const VerticalGrayLine: FC<{ level: number }> = ({ level }) => (
  <div
    className="absolute left-[19px] top-0 h-full w-px bg-gray-200"
    style={{ marginLeft: `${level * 20}px` }}
  />
)

export const TreeNodes: FC<TreeNodesProps> = ({
  nodes,
  data,
  level = 0,
  onSelect,
  searchTerm,
  focusedNodeId,
  onFocusNode,
  expandedNodes,
  onToggleExpand,
  selectedNodeId,
  disabledNodeIds
}) => {
  if (nodes.length === 0) {
    return (
      <Callout>
        <CalloutText>No organizations found</CalloutText>
      </Callout>
    )
  }

  return (
    <>
      {nodes.map(node => {
        // Use filtered data for hasChildren when searching, full data when not searching
        const nodeHasChildren = searchTerm
          ? hasChildrenInFiltered(node, data)
          : hasChildren(node, data)
        const isExpanded = expandedNodes.has(node.network.id)
        const isDisabled = disabledNodeIds.has(node.network.id)
        const isContractExpired =
          'isContractExpired' in node.network &&
          !!node.network.isContractExpired
        const children = getChildren(node, data)
        const isFocused = node.network.id === focusedNodeId
        const isSelected = node.network.id === selectedNodeId

        return (
          <div key={node.network.id}>
            <TreeItem
              node={node}
              level={level}
              hasChildren={nodeHasChildren}
              isExpanded={isExpanded}
              isHighlighted={isFocused}
              isSelected={isSelected}
              isDisabled={isDisabled}
              isContractExpired={isContractExpired}
              searchTerm={searchTerm}
              onClick={() => {
                if (isDisabled) {
                  return
                }
                onFocusNode(node.network.id)
                onSelect(node)
              }}
              onToggle={e => {
                e.preventDefault()
                e.stopPropagation()
                if (isDisabled) {
                  return
                }
                onToggleExpand(node.network.id)
              }}
            />
            {nodeHasChildren && isExpanded ? (
              <div className="relative">
                <VerticalGrayLine level={level} />
                <TreeNodes
                  nodes={children}
                  data={data}
                  level={level + 1}
                  onSelect={onSelect}
                  searchTerm={searchTerm}
                  focusedNodeId={focusedNodeId}
                  onFocusNode={onFocusNode}
                  expandedNodes={expandedNodes}
                  onToggleExpand={onToggleExpand}
                  selectedNodeId={selectedNodeId}
                  disabledNodeIds={disabledNodeIds}
                />
              </div>
            ) : null}
          </div>
        )
      })}
    </>
  )
}
